import React from 'react';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/pro-light-svg-icons';
import { faTimes } from '@fortawesome/pro-solid-svg-icons'
import qrcode from 'qrcode';
import FundkyButton from 'Parts/ui/components/FundkyButton';

import QRCode_en from './locales/QRCode_en.json';
import QRCode_fr from './locales/QRCode_fr.json';

import './QRCode.less';

class QRCode extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        }

        i18next.addResourceBundle('en', 'QRCode', QRCode_en);
        i18next.addResourceBundle('fr', 'QRCode', QRCode_fr);
    }

    componentDidMount() {
        try {
            // wait 1000 ms, to give the canvas element time to load on the page.
            setTimeout(() => {
                // get the canvas element by id
                const QRCodeCanvasElement = document.getElementById('qr-code');
                if (!QRCodeCanvasElement) { console.error('no canvas element with id: qr-code'); }

                // display QR code on html Canvas element
                qrcode.toCanvas(QRCodeCanvasElement, window.location.href, { width: 300, height: 300});


                qrcode.toDataURL(window.location.href, { errorCorrectionLevel: 'H' })
                .then(url => {
                    document.getElementById('qr-download-link').href = url;
                })
                .catch(err => console.error('QR generation failed', err));

            }, 1000);
        } catch (err) {
            console.error(err)
        }
    }

    render() {
        const {
            t,
            QRCodeVisible,
            showQRFunc
        } = this.props;

        return (
            <div className={(QRCodeVisible ? "QRCodeBox ant-modal-content" : 'none')}>
                <div className='ant-modal-body qr-popup'>
                    <FundkyButton
                        className="FundkyModal--close"
                        type="text"
                        icon={faTimes}
                        size="large"
                        action={{ func: () => {showQRFunc(false)} }}
                    />
                    <canvas className="strict-canvas" id="qr-code"></canvas>
                    <a id="qr-download-link" class="ant-btn ant-btn-primary social-full-button" download="fundky_QRCode.png">
                        <FontAwesomeIcon icon={faDownload} /> <span>{t('Download')}</span>
                    </a>
                </div>
            </div>
        );
    }
}

export default translate('QRCode')(QRCode);